import tw from "twin.macro";

export const CardSection = tw.div`min-h-[184.063rem] bg-[#0E1222] -mt-[0.063rem]`;
